// reducers/connect/instances.js

export function connectInstancesHasErrored(state = false, action) {
  switch (action.type) {
    case 'CONNECT_INSTANCES_HAS_ERRORED':
      return action.hasErrored;
    default:
      return state;
  }
}

export function connectInstancesIsLoading(state = true, action) {
  switch (action.type) {
    case 'CONNECT_INSTANCES_IS_LOADING':
      return action.isLoading;
    default:
      return state;
  }
}

export function connectInstances(state = {}, action) {
  switch(action.type) {
    case 'CONNECT_INSTANCES_FETCH_DATA_SUCCESS':
      return action.obj;
    default:
      return state;
  }
}